var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9326 5.03117C11.834 4.4135 13.0586 5.0589 13.0586 6.15159V16.3203C13.0586 17.4468 11.7662 18.0837 10.8729 17.3974L7.48711 14.7962H4.12387C3.37373 14.7962 2.76562 14.1881 2.76562 13.438V9.11334C2.76562 8.3632 3.37373 7.75509 4.12387 7.75509H6.95757L10.9326 5.03117Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8516 8.24023 L13.8516 8.24023C14.7254 8.24023 15.4338 8.94864 15.4338 9.8225V12.8218C15.4338 13.6957 14.7254 14.4041 13.8516 14.4041 L13.8516 14.4041V8.24023Z",
    fill: "#EA1763"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18284 13.6094C7.68293 13.6094 8.08834 14.0148 8.08834 14.5149L8.08834 19.3442C8.08834 19.8443 7.68293 20.2497 7.18284 20.2497C6.68275 20.2497 6.27734 19.8443 6.27734 19.3442L6.27734 14.5149C6.27734 14.0148 6.68275 13.6094 7.18284 13.6094Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3828 11.2985C16.3828 10.8818 16.7206 10.5439 17.1374 10.5439H20.5566C20.9733 10.5439 21.3112 10.8818 21.3112 11.2985C21.3112 11.7153 20.9733 12.0531 20.5566 12.0531H17.1374C16.7206 12.0531 16.3828 11.7153 16.3828 11.2985Z",
    fill: "#F28520"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9577 14.4447C15.6938 14.7672 15.7413 15.2426 16.0638 15.5065L18.248 17.294C18.5705 17.5579 19.0459 17.5104 19.3098 17.1879C19.5738 16.8654 19.5263 16.39 19.2038 16.126L17.0195 14.3386C16.697 14.0747 16.2216 14.1222 15.9577 14.4447Z",
    fill: "#F28520"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3118 5.4193C19.5758 5.74181 19.5283 6.21722 19.2058 6.48115L17.0216 8.26857C16.699 8.5325 16.2236 8.48501 15.9597 8.16249C15.6958 7.83998 15.7433 7.36457 16.0658 7.10064L18.25 5.31321C18.5725 5.04929 19.0479 5.09678 19.3118 5.4193Z",
    fill: "#F28520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.a9811f2e37f42e2ab3163f488accea6b.svg";
export { ForwardRef as ReactComponent };